export async function removeAfterConfirmation(
  fileName: string,
  confirmRemoval: (message: string) => boolean,
  removeFile: () => Promise<void>,
): Promise<boolean> {
  if (!confirmRemoval(`Xóa “${fileName}”?`)) return false
  await removeFile()
  return true
}
